module.exports = __webpack_public_path__ + "img/face-persevering.10d7ea17.svg";